export default {
    methods: {

        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("fecha_desde", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_desde + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_hasta", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_hasta + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("total_dias", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.total_dias + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("secuencia", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.secuencia + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            return cf.runFilters();
        },

        filterFechaDesde(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_desde: val
            });
        },
        filterFechaHasta(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_hasta: val
            });
        },
        filterTotalDias(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                total_dias: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
        filterSecuencia(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                secuencia: val
            });
        },
        
        recargar() {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_desde: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_hasta: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                total_dias: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias_programar: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                secuencia: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/vacaciones/mixins/filtrosProgramacion.js